exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container.fluid{padding:0}.v-content{height:100%}.v-list--three-line .v-list__tile__sub-title{height:42px}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/containers/Full.vue"],"names":[],"mappings":"AACA,iBACE,SAAW,CACZ,AAED,WACE,WAAa,CACd,AACD,6CACA,WAAa,CACZ","file":"Full.vue","sourcesContent":["\n.container.fluid {\n  padding: 0;\n}\n/*VN instead fill-height for container, because fill-height center items also*/\n.v-content {\n  height: 100%;\n}\n.v-list--three-line .v-list__tile__sub-title {\nheight: 42px;\n}\n/*.v-snack--multi-line .v-snack__content {*/\n  /*padding: 8px;*/\n/*}*/\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-297bbcaa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/containers/Full.vue
// module id = 972
// module chunks = 1